export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Éxito"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
}